'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodashObjectMapValues = require('lodash/object/mapValues');

var _lodashObjectMapValues2 = _interopRequireDefault(_lodashObjectMapValues);

var _lodashObjectPick = require('lodash/object/pick');

var _lodashObjectPick2 = _interopRequireDefault(_lodashObjectPick);

var _lodashObjectPairs = require('lodash/object/pairs');

var _lodashObjectPairs2 = _interopRequireDefault(_lodashObjectPairs);

var _lodashArrayZipObject = require('lodash/array/zipObject');

var _lodashArrayZipObject2 = _interopRequireDefault(_lodashArrayZipObject);

var _lodashObjectForOwn = require('lodash/object/forOwn');

var _lodashObjectForOwn2 = _interopRequireDefault(_lodashObjectForOwn);

var _lodashObjectSet = require('lodash/object/set');

var _lodashObjectSet2 = _interopRequireDefault(_lodashObjectSet);

var _props2 = require('./props');

var _props3 = _interopRequireDefault(_props2);

var _Layout = require('./Layout');

var _Layout2 = _interopRequireDefault(_Layout);

var _Controls = require('./Controls');

var _Controls2 = _interopRequireDefault(_Controls);

var _stringify = require('./stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var flattenObjProps = function flattenObjProps(prop, path) {
  return _lodashObjectPairs2['default'](prop).map(function (_ref) {
    var key = _ref[0];
    var value = _ref[1];

    var fullPath = [].concat(path, [key]);

    if (value.type !== 'shape') {
      return [[fullPath.join('.'), value]];
    }

    return flattenObjProps(value.props, fullPath);
  }).reduce(function (head, tail) {
    return head.concat(tail);
  }, []);
};

var flattenProps = function flattenProps(props) {
  var path = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
  return _lodashArrayZipObject2['default'](flattenObjProps(props, path));
};

var nestProps = function nestProps(flatProps) {
  var props = {};

  _lodashObjectForOwn2['default'](flatProps, function (value, key) {
    _lodashObjectSet2['default'](props, key, value);
  });

  return props;
};

var getValueProps = function getValueProps(props) {
  return _lodashObjectPick2['default'](props, function (x) {
    return x.type === 'value';
  });
};
var getCallbackProps = function getCallbackProps(props) {
  return _lodashObjectPick2['default'](props, function (x) {
    return x.type === 'callback';
  });
};

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo',

  propTypes: {
    props: _react.PropTypes.object,
    fullWidth: _react.PropTypes.bool,
    target: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
    children: _react.PropTypes.func,
    codeIndentDepth: _react.PropTypes.number,
    background: _Layout2['default'].propTypes.background
  },

  statics: { props: _props3['default'] },

  getDefaultProps: function getDefaultProps() {
    return {
      props: {},
      fullWidth: false,
      codeIndentDepth: 3,
      background: 'light'
    };
  },

  getInitialState: function getInitialState() {
    var props = this.props.props;

    var flatProps = flattenProps(props);

    return {
      values: _lodashObjectMapValues2['default'](getValueProps(flatProps), function (x) {
        return x.initialValue;
      }),
      logs: _lodashObjectMapValues2['default'](getCallbackProps(flatProps), function () {
        return [];
      })
    };
  },

  getCallbacks: function getCallbacks(props) {
    var _this = this;

    return _lodashObjectMapValues2['default'](getCallbackProps(props), function (x, key) {
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var map = x.map;
        var callbackType = x.callbackType;

        var result = map ? _stringify2['default'](map.apply(undefined, args)) : args.map(_stringify2['default']).join(', ');
        var logs = _this.state.logs;

        var nextLog = callbackType === 'logLatest' ? [result] : [result].concat(logs[key]);
        _this.setState(function (state) {
          var _extends2;

          return { logs: _extends({}, state.logs, (_extends2 = {}, _extends2[key] = nextLog, _extends2)) };
        });
      };
    });
  },

  updateValues: function updateValues(changes) {
    var updater = typeof changes === 'function' ? function (state) {
      return { values: changes(state.values) };
    } : function (state) {
      return { values: _extends({}, state.values, changes) };
    };
    this.setState(updater);
  },

  render: function render() {
    var _state = this.state;
    var values = _state.values;
    var logs = _state.logs;
    var _props = this.props;
    var children = _props.children;
    var fullWidth = _props.fullWidth;
    var codeIndentDepth = _props.codeIndentDepth;
    var background = _props.background;
    var props = _props.props;

    var flatProps = flattenProps(props);

    var targetProps = nestProps(_extends({}, values, this.getCallbacks(flatProps)));
    var targetEl = children ? children(targetProps, this.updateValues) : _react2['default'].createElement(this.props.target, targetProps);

    var controlsProps = {
      logs: logs,
      values: values,
      codeIndentDepth: codeIndentDepth,
      targetEl: targetEl,
      onTop: fullWidth,
      props: getValueProps(flatProps),
      onChange: this.updateValues
    };
    var controlsEl = _react2['default'].createElement(_Controls2['default'], controlsProps);

    var layoutProps = { fullWidth: fullWidth, targetEl: targetEl, controlsEl: controlsEl, background: background };
    return _react2['default'].createElement(_Layout2['default'], layoutProps);
  }

});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/index.js
// module id = 23
// module chunks = 0